import { Directory } from "@app/shared/models";
import { TimeSlotRangeStepMinutes } from "@app/shared/models/time-slot-range-step-minutes";
import { safeGet } from "./secure/safe-get";

export function convertArrayToObject(array: any[], key: string) {
  return array.reduce(
    (obj, item) => ({ ...obj, [safeGet(item, key)]: item }),
    {},
  );
}

export function removeObjectProperty(originalObj: any, array: string[]) {
  return array.reduce((obj, key: string) => {
    const { [key]: value, ...rest } = obj;

    return rest;
  }, originalObj);
}

export function getObjectPropertyToArray(array: any[], key: string) {
  return array.reduce((prev, curr) => [...prev, ...[safeGet(curr, key)]], []);
}

export function getUniqueId(): string {
  return `_${Math.random().toString(36).substr(2, 9)}`;
}

// **ахуенный код, надежный блять, как швейцарские часы (нет). Лебовски
export function getTimeSlotRange(
  stepMinutes: TimeSlotRangeStepMinutes,
): string[] {
  return Array(24)
    .fill(null)
    .reduce((hourRange, _, hourIndex) => {
      const numTimeSlots = 60 / stepMinutes;

      return Array(numTimeSlots)
        .fill(null)
        .reduce((_1: any, _2: any, timeSlotIndex) => {
          const hours = (hourIndex + "").padStart(2, "0");
          const minutes = (timeSlotIndex * stepMinutes + "").padStart(2, "0");
          hourRange.push(`${hours}:${minutes}`);

          return hourRange;
        }, hourRange);
    }, []);
}

export function excludedHandbook(arr: any[], excludedArr: any[]): any[] {
  return (
    arr
      // .filter((itemFirst: Directory): boolean => itemFirst.id > 0)
      .filter(
        (itemSecond: Directory) =>
          !excludedArr.some(
            (excludedItem) => excludedItem.id === itemSecond.id,
          ),
      )
  );
}

export function removeDuplicatesArr(arr: any[], fieldFilter = "id"): any[] {
  return arr.filter(
    (item, index: number, self: any[]): boolean =>
      self.findIndex(
        (element) =>
          safeGet(element, fieldFilter) === safeGet(item, fieldFilter),
      ) === index,
  );
}

export function hostnameReplace(hostname: string): string | undefined {
  const pattern =
    /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?(?:stage\.)?([^:\/\n]+)/im;

  return hostname.match(pattern)?.[1];
}

export function isEqualArray(firstArr: any[], secondArr: any[]): boolean {
  if (firstArr.length !== secondArr.length) {
    return false;
  }

  for (let index = 0; index < firstArr.length; index++) {
    const obj1 = safeGet(firstArr, String(index));
    const obj2 = safeGet(secondArr, String(index));

    const keys = Object.keys(obj1);

    for (const key of keys) {
      if (safeGet(obj1, key) !== safeGet(obj2, key)) {
        return false;
      }
    }
  }

  return true;
}
